<template>
  <div>
    <nav-bar />
    <b-container fluid>
      <b-row>
        <b-col>
          <b-overlay :show="loading">
            <v-card>
              <v-card-title>
                <b-row no-gutters align-v="center">
                  <b-col>GRUPOS DE USUÁRIO</b-col>
                  <b-col cols="auto">
                    <v-btn text color="primary" @click="newUserGroup">
                      <v-icon> mdi-plus </v-icon>
                      NOVO
                    </v-btn>
                  </b-col>
                </b-row>
              </v-card-title>
              <v-card-text>
                <!-- GRUPOS DE USUÁRIO -->
                <v-expansion-panels flat>
                  <v-expansion-panel
                    v-for="(user_group, user_group_index) in user_groups"
                    :key="`${user_group_index}`"
                  >
                    <v-expansion-panel-header
                      :disable-icon-rotate="user_group.hasError"
                    >
                      <template v-if="user_group.hasError" #actions>
                        <v-icon color="error"> mdi-alert-circle </v-icon>
                      </template>
                      <h6>GRUPO: {{ user_group.name }}</h6>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <b-row align-v="center">
                        <b-col cols="auto">
                          <v-btn
                            icon
                            color="red"
                            @click="delUserGroup(user_group_index)"
                          >
                            <v-icon>mdi-trash-can</v-icon>
                          </v-btn>
                        </b-col>
                        <b-col cols="auto">
                          <v-btn
                            :disabled="user_group_index === 0"
                            icon
                            @click="
                              user_groups = arraySwapItemPosition(
                                user_groups,
                                user_group_index,
                                user_group_index - 1
                              )
                            "
                          >
                            <v-icon> mdi-arrow-up </v-icon>
                          </v-btn>
                          <v-btn
                            :disabled="
                              user_group_index === user_groups.length - 1
                            "
                            icon
                            @click="
                              user_groups = arraySwapItemPosition(
                                user_groups,
                                user_group_index,
                                user_group_index + 1
                              )
                            "
                          >
                            <v-icon> mdi-arrow-down </v-icon>
                          </v-btn>
                        </b-col>
                        <b-col cols="6">
                          <v-text-field
                            dense
                            outlined
                            hide-details
                            label="NOME"
                            v-model="user_group.name"
                          >
                          </v-text-field>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <v-textarea
                            dense
                            outlined
                            hide-details
                            label="DESCRIÇÃO"
                            v-model="user_group.description"
                          ></v-textarea>
                        </b-col>
                      </b-row>
                      <errors-messages :errors="user_group.errors" />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <errors-messages :errors="errors" />
              </v-card-text>
              <v-card-actions>
                <b-row no-gutters align-h="end">
                  <b-col cols="auto">
                    <v-btn text color="green" @click="validate">
                      <v-icon> mdi-check </v-icon>
                      SALVAR
                    </v-btn>
                  </b-col>
                </b-row>
              </v-card-actions>
            </v-card>
          </b-overlay>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import api from "../services/api";
import NavBar from "../templates/NavBar.vue";
import { arraySwapItemPosition } from "../lib/functions";
import { validateString } from "../lib/validate";
import ErrorsMessages from "../templates/components/ErrorsMessages.vue";
import toast from "../components/ToastNotification";

export default {
  name: "RestHomeUserGroups",

  components: { NavBar, ErrorsMessages },

  data() {
    return {
      errors: [],
      loading: false,

      /**
       * @type {{
       *   name: string,
       *   description: string,
       *   errors: [],
       * }[]}
       */
      user_groups: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    arraySwapItemPosition,

    async retrieve() {
      await this.getUserGroups();
    },

    async newUserGroup() {
      this.user_groups.push({
        name: "",
        description: "",
        errors: [],
      });
    },

    async delUserGroup(user_group_index) {
      this.user_groups.splice(user_group_index, 1);
    },

    async getUserGroups() {
      try {
        this.loading = true;

        const response = await api.get(
          "/admin/rest-home-deploy-script/user-groups"
        );
        const { error, errors, user_groups } = response.data;

        if (error) {
          this.errors = errors;
          this.user_groups = [];
        } else {
          this.user_groups = user_groups;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async validate() {
      try {
        this.loading = true;

        //#region validação
        let valid = true;
        let reason;

        //#region grupos de usuário
        for (let user_group of this.user_groups) {
          user_group.errors = [];
          user_group.hasError = false;

          reason = validateString(user_group.name, {
            minLength: {
              expected: 3,
              reason: "Nome deve conter ao menos 3 caracteres",
            },
            maxLength: {
              expected: 64,
              reason: "Nome deve conter até 64 caracteres",
            },
          });
          if (reason) user_group.errors.push(reason);

          reason = validateString(user_group.description, {
            minLength: {
              expected: 3,
              reason: "Descrição deve conter ao menos 3 caracteres",
            },
            maxLength: {
              expected: 255,
              reason: "Descrição deve conter até 255 caracteres",
            },
          });
          if (reason) user_group.errors.push(reason);

          if (user_group.errors.length > 0) {
            user_group.hasError = true;
            valid = false;
          }
        }
        //#endregion

        if (!valid) {
          this.loading = false;
          return;
        }
        //#endregion

        const data = { user_groups: this.user_groups };
        const response = await api.patch(
          "/admin/rest-home-deploy-script/user-groups",
          data
        );
        const { error, errors, message, user_groups } = response.data;

        if (error) {
          this.errors = errors;
          if (user_groups) this.user_groups = user_groups;
        } else {
          this.errors = [];
          toast(message, "success");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
.v-expansion-panels--flat:not(:empty) {
  border: 2px solid #f5f5f5;
}

.v-expansion-panel--active:not(:first-child) {
  border-top: 2px solid #f5f5f5;
}

.v-expansion-panel--active:not(:last-child) {
  border-bottom: 2px solid #f5f5f5;
}
</style>